import './review.scss';

import { t } from 'i18next';

import { Divider } from '@sola/ark-core/atoms/divider/divider.js';
import {
  Prominence,
  Purposes,
  Sizes,
  Text,
  Variants,
} from '@sola/ark-core/atoms/text/text.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

export type ReviewProps = {
  name?: string;
  sponsorDuration?: string;
  location?: string;
  rating?: number;
  reviewTitle?: string;
  review?: string;
  recommendsCompassion?: boolean;
};

export const Review: React.FC<ReviewProps> = ({
  name,
  sponsorDuration,
  location,
  rating,
  reviewTitle,
  review,
  recommendsCompassion,
}) => {
  let time;
  switch (sponsorDuration) {
    case '25 Years or More':
      time = t('skippy:reviews.sponsor', { context: 'twentyFiveYear' });
      break;
    case '10 to 25 Years':
      time = t('skippy:reviews.sponsor', { context: 'tenYear' });
    case '1 to 10 Years':
      time = t('skippy:reviews.sponsor', { context: 'oneYear' });
      break;
    case 'New Sponsor':
      time = t('skippy:reviews.sponsor', { context: 'new' });
      break;
    default:
      time = t('skippy:reviews.sponsor', { context: 'na' });
      break;
  }

  const where =
    location && location !== ''
      ? t('skippy:reviews.from', { place: location })
      : '';
  return (
    <div className="Review flex flex-col">
      <Text
        prominence={'potent' as Prominence}
        size={'xl' as Sizes}
        variant={'label' as Variants}
      >
        {name}
      </Text>
      <Text
        purpose={'neutral' as Purposes}
        prominence={'moderate' as Prominence}
        size={'lg' as Sizes}
        variant={'label' as Variants}
      >
        {t('skippy:reviews.description', { time, where })}
      </Text>
      <Divider purpose="neutral" className="my-comfy-md" />
      <div className="flex-row mb-comfy-md">
        {[1, 2, 3, 4, 5].map((element) =>
          rating && rating < element ? (
            <ArkIcon
              iconName="star-01"
              key={element}
              className="Review__star--grey"
            />
          ) : (
            <ArkIcon
              iconName="star-01"
              key={element}
              className="Review__star--gold"
            />
          ),
        )}
      </div>
      <div className="flex flex-col gap-comfy-xs">
        <Text
          prominence={'potent' as Prominence}
          size={'xl' as Sizes}
          variant={'label' as Variants}
        >
          {reviewTitle}
        </Text>
        <Text
          size={'sm' as Sizes}
          variant={'body' as Variants}
          purpose={'neutral' as Purposes}
          prominence={'mild' as Prominence}
        >
          {review}
        </Text>
      </div>
      {recommendsCompassion && (
        <div className="flex flex-row gap-snug-md pt-comfy-xl items-center">
          <ArkIcon iconName="check-circle" className="Review__check" />
          <Text
            size={'lg' as Sizes}
            prominence={'mild' as Prominence}
            variant={'label' as Variants}
            purpose={'neutral' as Purposes}
          >
            {t('skippy:reviews.recommend')}
          </Text>
        </div>
      )}
    </div>
  );
};
